// src/services/integrationService.js
import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";

const PROVIDER = ENDPOINTS.INTEGRATION.WHATSAPP_PROVIDER;

export const integrationService = {
 getWhatsAppProviders: async () => {
  const res = await apiClient.get(PROVIDER.GET_ALL);
 
  return res; 
},


  addWhatsAppProvider: (data) => {
    return apiClient.post(PROVIDER.CREATE, data);
  },

  updateWhatsAppProvider: (id, data) => {
    return apiClient.put(PROVIDER.UPDATE(id), data);
  },

  deleteWhatsAppProvider: (id) => {
    return apiClient.delete(PROVIDER.DELETE(id));
  },

  activateStatus: (id) => {
    return apiClient.put(PROVIDER.ACTIVATE(id), {});
  },

  deactivateStatus: (id) => {
    return apiClient.put(PROVIDER.DEACTIVATE(id), {});
  },
};

export default integrationService;
